export const CREATE_SESSION = /* GraphQL */ `
  mutation CreateSession($phoneNumber: String) {
    createSession(phoneNumber: $phoneNumber) {
      sessionId
      userId
      status
      currentStep
      lastUpdatedAt
      expiresAt
      bookingState {
        selectedSeats
        passengers {
          passengerId
          firstName
          lastName
          dateOfBirth
          passportNumber
          nationality
        }
      }
    }
  }
`;

export const UPDATE_BOOKING_SESSION = /* GraphQL */ `
  mutation UpdateBookingSession($sessionId: ID!, $patch: SessionPatch!) {
    updateBookingSession(sessionId: $sessionId, patch: $patch) {
      userId
      sessionId
      status
      currentStep
      lastUpdatedAt
      bookingState {
        searchParams {
          origin
          destination
          departureDate
          returnDate
          cabinClass
          passengerCount
        }
        selectedFlight {
          flightId
          flightNumber
          airline
          origin
          destination
          departureTime
          arrivalTime
          durationMinutes
          cabinClass
          price
          currency
        }
        selectedSeats
        passengers {
          passengerId
          firstName
          lastName
          dateOfBirth
          passportNumber
          nationality
        }
        payment {
          intentId
          status
          amountCents
          currency
        }
        confirmationCode
      }
      agentOverride {
        targetStep
        prefillSeat
        message
      }
    }
  }
`;

export const GET_PROFILE_PHOTO_UPLOAD_URL = /* GraphQL */ `
  mutation GetProfilePhotoUploadUrl($contentType: String!) {
    getProfilePhotoUploadUrl(contentType: $contentType) {
      uploadUrl
      photoUrl
    }
  }
`;

export const UPDATE_PREFERENCES = /* GraphQL */ `
  mutation UpdatePreferences($input: TravelPreferencesInput!) {
    updatePreferences(input: $input) {
      prefSeatLocation
      prefCabinClass
      prefMealType
      prefHomeAirport
      prefTravelType
      prefLanguage
      birthDate
      passportNumber
      addressLine1
      addressCity
      addressState
      addressZip
      addressCountry
      wizardCompleted
    }
  }
`;

export const CANCEL_BOOKING = /* GraphQL */ `
  mutation CancelBooking($confirmationCode: String!) {
    cancelBooking(confirmationCode: $confirmationCode)
  }
`;

export const UPDATE_BOOKING = /* GraphQL */ `
  mutation UpdateBooking($confirmationCode: String!, $selectedSeats: [String], $passengers: [BookingPassengerInput]) {
    updateBooking(confirmationCode: $confirmationCode, selectedSeats: $selectedSeats, passengers: $passengers)
  }
`;

export const UPDATE_ADMIN_CONFIG = /* GraphQL */ `
  mutation UpdateAdminConfig($input: AdminConfigInput!) {
    updateAdminConfig(input: $input) {
      connectInstanceId
      tagFilters { key value }
      lookbackDays
      updatedAt
    }
  }
`;

export const UPDATE_USER_ROLE = /* GraphQL */ `
  mutation UpdateUserRole($sub: String!, $makeAdmin: Boolean!) {
    updateUserRole(sub: $sub, makeAdmin: $makeAdmin)
  }
`;

export const DELETE_USER = /* GraphQL */ `
  mutation DeleteUser($sub: String!, $mode: String!) {
    deleteUser(sub: $sub, mode: $mode)
  }
`;

export const CONFIRM_BOOKING = /* GraphQL */ `
  mutation ConfirmBooking($sessionId: ID!) {
    confirmBooking(sessionId: $sessionId) {
      confirmationCode
      sessionId
      confirmedAt
    }
  }
`;
